export { default as VehicleCostSlot } from './VehicleCostSlot';
